import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion } from 'react-bootstrap';
import PayMethodCrudService from '../../../services/PayMethodCrudService';
import InputText from '../../../components/Forms/InputText';
import TabMethodImages from './TabMethodImages';

export default function ModalPayMethod({ show, handleClose, dataItem, setRenderRows }) {
  const isViewOrDelete = dataItem.typeView === 'View' || dataItem.typeView === 'Delete';

  const [name, setName] = useState('');
  const [satPaymethod, setSatPaymethod] = useState('');
  const [commissionIsCondonable, setCommissionIsCondonable] = useState(false);
  const [chargebackInsurance, setChargebackInsurance] = useState(false);
  const [commission, setCommission] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [description, setDescription] = useState('');
  const [instructions, setInstructions] = useState('');
  const [url, setUrl] = useState('');
  const [paymentInstructions, setPaymentInstructions] = useState('');
  const [types, setTypes] = useState({});
  const [tempImages, setTempImages] = useState(['/default/default.jpg']);
  const [enableChangeImage, setEnableChangeImage] = useState(true);
  const [selectedImages, setSelectedImages] = useState({});

  const [successMessage, setSuccessMessage] = useState(null);
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);

  useEffect(() => {
    if (show && dataItem.codeItem > 0) {

      PayMethodCrudService.getMethodById(dataItem.codeItem).then(async res => {
        let currentMethod = res.data.data[0];

        setName(currentMethod.name);
        setCommission(currentMethod.commission);
        setEnabled(currentMethod.enabled);
        setDescription(currentMethod.description);
        setInstructions(currentMethod.instructions);
        setSatPaymethod(currentMethod.satPaymethod);
        setCommissionIsCondonable(currentMethod.commissionIsCondonable);
        setChargebackInsurance(currentMethod.chargebackInsurance);
        setTypes(currentMethod.type);
        setUrl(currentMethod.url);
        setPaymentInstructions(currentMethod.paymentInstructions);
        setTempImages(currentMethod.images);
      });
    } else {

      setName('');
      setCommission('');
      setEnabled(false);
      setDescription('');
      setInstructions('');
      setSatPaymethod('');
      setCommissionIsCondonable(false);
      setChargebackInsurance(false);
      setTypes({});
      setUrl('');
      setPaymentInstructions('');
      setTempImages(['/default/default.jpg']);
      setEnableChangeImage(true);
      setSelectedImages({});

      setEnableSaveChanges(true);
      setSuccessMessage(null);

    }
  }, [dataItem, show]);

  const formFieldsHandler = (event) => {
    switch (event.target.name) {
      case 'Name': setName(event.target.value); break;
      case 'SatPaymethod': setSatPaymethod(parseInt(event.target.value)); break;
      case 'CommissionIsCondonable': setCommissionIsCondonable(event.target.value); break;
      case 'ChargebackInsurance': setChargebackInsurance(event.target.value); break;
      case 'Commission': setCommission(parseFloat(event.target.value)); break;
      case 'Enabled': setEnabled(event.target.value); break;
      case 'Description': setDescription(event.target.value); break;
      case 'Instructions': setInstructions(event.target.value); break;
      case 'ShowApiKeys': setTypes({ ...types, ['showApiKeys']: (event.target.value) }); break;
      case 'ShowTable': setTypes({ ...types, ['showTable']: (event.target.value) }); break;
      case 'ShowUrl': setTypes({ ...types, ['showUrl']: (event.target.value) }); break;
      case 'UrlProduction': setTypes({ ...types, ['urlProduction']: (event.target.value) }); break;
      case 'UrlSandbox': setTypes({ ...types, ['urlSandbox']: (event.target.value) }); break;
      case 'TypeName': setTypes({ ...types, ['name']: (event.target.value) }); break;
      case 'Url': setUrl(event.target.value); break;
      case 'PaymentInstructions': setPaymentInstructions(event.target.value); break;

      default: break;
    }
    setEnableSaveChanges(false);
  };

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }
  
  const handleSubmit = async () => {
    try {
      let updateMethod = { name, satPaymethod, commissionIsCondonable, chargebackInsurance, commission, enabled, description, type: types, instructions, url, paymentInstructions, images: tempImages };
      //console.log(updateMethod);
      if (!dataItem.codeItem && dataItem.typeView === 'Create') {
        PayMethodCrudService.createMethod(updateMethod).then(res => {
          sleep(1500).then(() => {
            handleClose();
            window.location.href = '/catalogs/paymethods';
          });
        });
      } else {
      await PayMethodCrudService.updateMethod(updateMethod, dataItem.codeItem);
      setSuccessMessage('success');
      await sleep(1500);
      handleClose();
      window.location.href = '/catalogs/paymethods';
    }
    } catch (err) {
      console.error(err);
      if (err.response && err.response.status !== 200) {
        setSuccessMessage('danger');
      }
    }
  };

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time))
  }

  const submitButton = !isViewOrDelete && (
    <Button
      type="button"
      disabled={enableSaveChanges}
      onClick={handleSubmit}
    >
      Save Changes
    </Button>
  );

  const closeButton = <Button variant="secondary" onClick={handleClose}> Close </Button>;

  return (<>
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem} </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <Tabs defaultActiveKey="main" id="justify-tab-example" className="mb-3" justify>
          <Tab eventKey="main" title="Data Method">

            <Row className="mb-3">
              <InputText defaultValue={name} label={'Name'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'5'} />

              <Form.Group as={Col} md="4" key={'Enabled'}>
                <Form.Label>Enabled</Form.Label>
                <Form.Select
                  name="Enabled"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete ? true : false}
                  disabled={isViewOrDelete ? true : false}
                  value={enabled}
                >
                  <option key='false' value='false' >False</option>
                  <option key='true' value='true' >True</option>
                </Form.Select>
              </Form.Group>

              <InputText defaultValue={satPaymethod} label={'SatPaymethod'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'3'} />
            </Row>
            <Row className="mb-3">

              <InputText defaultValue={commission} label={'Commission'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'2'} />

              <Form.Group as={Col} md="3" key={'IsCondonable'}>
                <Form.Label>IsCondonable</Form.Label>
                <Form.Select
                  name="IsCondonable"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete ? true : false}
                  disabled={isViewOrDelete ? true : false}
                  value={commissionIsCondonable}
                >
                  <option key='false' value='false' >False</option>
                  <option key='true' value='true' >True</option>
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="3" key={'chargebackInsurance'}>
                <Form.Label>chargebackInsurance</Form.Label>
                <Form.Select
                  name="chargebackInsurance"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete ? true : false}
                  disabled={isViewOrDelete ? true : false}
                  value={chargebackInsurance}
                >
                  <option key='false' value='false' >False</option>
                  <option key='true' value='true' >True</option>
                </Form.Select>
              </Form.Group>

            </Row>

            <Row className="mb-3">
              <InputText defaultValue={description} label={'Description'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'12'} />
            </Row>

            <Row className="mb-3">
              <InputText defaultValue={instructions} label={'Instructions'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'12'} />
            </Row>

            <Row className="mb-3">
              <InputText defaultValue={url} label={'Url'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'12'} />
            </Row>

            <Row className="mb-3">
              <InputText defaultValue={paymentInstructions} label={'PaymentInstructions'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'12'} />
            </Row>

            {submitButton}{'  '}{'  '}{closeButton}

          </Tab>
          <Tab eventKey="types" title="Types">
            <Row className="mb-3">
              <Form.Group as={Col} md="2" key={'types'}>
                <Form.Label>Types : </Form.Label>
              </Form.Group>

              <Form.Group as={Col} md="3" key={'ShowApiKeys'}>
                <Form.Label>ShowApiKeys</Form.Label>
                <Form.Select
                  name="ShowApiKeys"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete ? true : false}
                  disabled={isViewOrDelete ? true : false}
                  value={types.showApiKeys}
                >
                  <option key='false' value='false' >False</option>
                  <option key='true' value='true' >True</option>
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="3" key={'ShowTable'}>
                <Form.Label>ShowTable</Form.Label>
                <Form.Select
                  name="ShowTable"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete ? true : false}
                  disabled={isViewOrDelete ? true : false}
                  value={types.showTable}
                >
                  <option key='false' value='false' >False</option>
                  <option key='true' value='true' >True</option>
                </Form.Select>
              </Form.Group>


              <Form.Group as={Col} md="3" key={'ShowUrl'}>
                <Form.Label>ShowUrl</Form.Label>
                <Form.Select
                  name="ShowUrl"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete ? true : false}
                  disabled={isViewOrDelete ? true : false}
                  value={types.showUrl}
                >
                  <option key='false' value='false' >False</option>
                  <option key='true' value='true' >True</option>
                </Form.Select>
              </Form.Group>

            </Row>

            <Row className="mb-3">
              <InputText defaultValue={types.urlProduction} label={'UrlProduction'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'4'} />
              <InputText defaultValue={types.urlSandbox} label={'UrlSandbox'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'4'} />
              <InputText defaultValue={types.name} label={'TypeName'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'4'} />
            </Row>

            {submitButton}{'  '}{'  '}{closeButton}

          </Tab>

          {dataItem.codeItem > 0 && (
            <Tab eventKey="images" title="images">
              <TabMethodImages tempImages={tempImages} setTempImages={setTempImages} setCloseButton={closeButton} codeMethod={dataItem.codeItem} isViewOrDelete={isViewOrDelete} handleClose={handleClose} enableChangeImage={enableChangeImage} setEnableChangeImage={setEnableChangeImage} selectedImages={selectedImages} setSelectedImages={setSelectedImages} setSuccessMessage={setSuccessMessage} />
            </Tab>
          )}
        </Tabs>

        {successMessage === 'danger' && (
          <Alert key="danger" variant="danger">
            ¡Method no actualizado!
          </Alert>
        )}
        {successMessage === 'success' && (
          <Alert key="success" variant="success">
            ¡Method Actualizado!
          </Alert>
        )}
      </Modal.Body>
    </Modal>
  </>)
}